import { render, staticRenderFns } from "./PackageMe.vue?vue&type=template&id=8dc86392"
import script from "./PackageMe.vue?vue&type=script&lang=js"
export * from "./PackageMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports